// @ts-nocheck
import axios from 'axios';
import { store } from 'store/store';

// set axios base url
axios.defaults.baseURL = window['configs'].baseURL;

// axios.interceptors.request.use(
//   config => {
//     const token = store.getState().signIn.accessToken;

//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }

//     return config;
//   },
//   error => {
//     Promise.reject(error);
//   }
// );

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
);
